import { createApiSlice } from 'app/createApiSlice'

export const processingReportApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'processingReport/hooks',
  endpoints(builder) {
    return {
      fetchProcessingReports: builder.query({
        query({
          sortby = 'creatorName',
          sortdir = 'ASC',
          s,
          page = 0,
          size = 10,
        }) {
          return {
            url: `/api/v1/bussines/processingreports/group`,
            params: {
              sortby,
              sortdir,
              s,
              page,
              size,
            },
          }
        },
        transformErrorResponse({ data, status }) {
          return {
            data,
            status,
          }
        },
      }),
      fetchDetailProcessingReports: builder.query({
        query({ processUniqueId }) {
          return {
            url: `/api/v1/bussines/processingreports/groupdetail`,
            params: {
              processUniqueId,
            },
          }
        },
        transformErrorResponse({ data, status }) {
          return {
            data,
            status,
          }
        },
      }),
    }
  },
})

export const {
  useFetchProcessingReportsQuery,
  useLazyFetchProcessingReportsQuery,
  useFetchDetailProcessingReportsQuery,
} = processingReportApiSlice
